import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import Properties from './Properties';
import StaticFluids from './StaticFluids';
import Considerations from './Considerations';
import Impulse from "./Impulse";
import MomentumAndForces from './MomentumAndForces';
import Hydro from "./Hydro";
import Boyles from "./Boyles";
import FluidKinematics from "./FluidKinematics";
import Bernoulli from "./Bernoulli";
import DimensionalAnalysis from "./DimensionalAnalysis";
import ExternalFlow from "./ExternalFlow";
import CompressibleFlow from "./CompressibleFlow";
import OpenChannel from "./OpenChannel";
import TurboMachinery from "./TurboMachinery";
import Advanced from "./Advanced";

const ChangeComponents = {
    properties: Properties,
    staticfluids: StaticFluids,
    considerations: Considerations,
    impulse: Impulse,
    momentumandforces: MomentumAndForces,
    hydro: Hydro,
    boyles: Boyles,
    fluidkinematics: FluidKinematics,
    bernoulli: Bernoulli,
    dimensionalanalysis: DimensionalAnalysis,
    externalflow: ExternalFlow,
    compressibleflow: CompressibleFlow,
    openchannel: OpenChannel,
    turbomachinery: TurboMachinery,
    advanced: Advanced,
  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }